module.exports = __webpack_public_path__ + "img/default-avatar.11d04741.png";